import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PrimeNGConfig } from 'primeng/api';
import Swal from 'sweetalert2';
import { AnnonceService } from '../annonce.service';
import { AgenciesService } from 'app/services/agencies/agencies.service';

@Component({
  selector: 'app-annonce',
  templateUrl: './annonce.component.html',
  styleUrls: ['./annonce.component.scss']
})
export class AnnonceComponent implements OnInit {

  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
 
  public announcements: any
  agencies: any;
  p: number = 1;
  
  // Variables pour sauvegarder l'état
  selectedCity: string = '';
  currentPage: number = 1;

  constructor(private agenciesService: AgenciesService, private Announcements: AnnonceService,
    private primengConfig: PrimeNGConfig
  ) { }

  ngOnInit() {
    // Restaurer l'état sauvegardé
    this.restoreState();
    this.getAnnouncements();
  }

  // Sauvegarder l'état actuel dans localStorage
  saveState() {
    const state = {
      selectedCity: this.selectedCity,
      currentPage: this.p
    };
    localStorage.setItem('annonceState', JSON.stringify(state));
  }

  // Restaurer l'état depuis localStorage
  restoreState() {
    const savedState = localStorage.getItem('annonceState');
    if (savedState) {
      const state = JSON.parse(savedState);
      this.selectedCity = state.selectedCity || '';
      this.p = state.currentPage || 1;
      this.currentPage = state.currentPage || 1;
    }
  }

  // Effacer l'état sauvegardé
  clearState() {
    localStorage.removeItem('annonceState');
  }

  getAnnouncements() {
    this.Announcements.getAnnouncements().subscribe((data: any) => {
      this.announcements = data
      console.log("liste des annonces", this.announcements);
      
      // Si une ville était sélectionnée, appliquer le filtre
      if (this.selectedCity) {
        this.agencies = this.announcements.filter((agency: any) => {
          return agency.phone_number_commercial !== "yes" && agency.ville === this.selectedCity;
        });
      } else {
        // Sinon, seulement filtrer par phone_number_commercial
        this.agencies = this.announcements.filter((agency: any) => {
          return agency.phone_number_commercial !== "yes";
        });
      }
      
      // Restaurer la page après chargement des données
      setTimeout(() => {
        this.p = this.currentPage;
      }, 100);
    });
  }

  deleteAgencies(id, i) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.Announcements.deleteItem(id).subscribe((response: any) => {
          console.log(response);

          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          this.agencies.splice(i, 1)
          
          // Sauvegarder l'état après suppression
          this.saveState();
        });
      }
    });
  }

  onCityChange(event: any) {
    const selectedCity = event.target.value;
    this.selectedCity = selectedCity;
    this.p = 1; // Retour à la première page quand on change de ville
    this.currentPage = 1;

    console.log("Selected City:", selectedCity);

    if (selectedCity) {
      this.agencies = this.announcements.filter((agency: any) => {
        const matchesCity = agency.ville === selectedCity;
        const matchesCommercial = agency.phone_number_commercial !== "yes";
        return matchesCity && matchesCommercial;
      });
      console.log("Filtered Agencies:", this.agencies);
    } else {
      this.agencies = this.announcements.filter((agency: any) => {
        return agency.phone_number_commercial !== "yes";
      });
      console.log("Showing All Agencies:", this.agencies);
    }
    
    // Sauvegarder l'état après changement de ville
    this.saveState();
  }

  approveA(id: string, i: number) {
    this.Announcements.approveAnnouncement(id).subscribe(
      (data: any) => {
        console.log('Approval successful:', data);
        // Sauvegarder l'état après approbation
        this.saveState();
      },
      (error) => {
        console.error('Error approving announcement:', error);
      }
    );
  }

  // Appeler cette méthode quand on change de page
  onPageChange(page: number) {
    this.p = page;
    this.currentPage = page;
    // Sauvegarder l'état quand on change de page
    this.saveState();
  }
}